import React from 'react';

// Bouton d'action inline, rendu comme un lien (classe .link-btn).
interface LinkButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  danger?: boolean;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  danger = false,
  className = '',
  type = 'button',
  children,
  ...rest
}) => {
  const classes = ['link-btn', danger ? 'danger' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
};

export default LinkButton;
